export const APP_STORE_URL = "https://apps.apple.com/app/id6766210474";
export const APP_GOOGLE_URL = "https://play.google.com/store/apps/details?id=cloud.irohana.study.learner";
